import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";

import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useNavigator } from "@/utils/NetworkCheck";
import { FileType } from "../../types";
import openDeleteModal from "../../contextModal/DeleteModal";
import styles from "./index.module.less";
import { sendIntentMessageToAI } from "@/utils/chat/message";
import { AI_CHAT_PREDICT, ChatMessageType } from "@/types/chat";
import { createPageUrl, isSupprotAbstract, joyaLog } from "../../util";
import { useTranslation } from "react-i18next";
import { isFocusEnv } from "@/utils";

function JoyspaceAbstract(props: any) {
  const { item: data } = props;
  const { t } = useTranslation("common");
  const { currentEmployee, appRuntimeEnv, onLine } = React.useContext<GlobalContextConfig>(
    GlobalContext
  );
  // 发送意图识别消息
  const sendIntentMessage = useCallback(
    async (item) => {
      console.log(item.page_type, "sendIntentMessage11");
      const message = {
        content: "",
        name: item.title,
        fileName: item.title,
        type: ChatMessageType.JOYSPACEFILE,
        url: createPageUrl(item, appRuntimeEnv.joyspaceHost),
        fileId: item.id,
        pageType: item.page_type
      };
      sendIntentMessageToAI({
        currentEmployee,
        message: message,
        predictType: AI_CHAT_PREDICT.FILE_SUMMARY,
        /* eslint-disable no-template-curly-in-string */
        prompt: "请根据以下材料，自动生成摘要：${text}"
      });
      joyaLog("AI-LIST-SUMMARY");
    },
    [currentEmployee, appRuntimeEnv]
  );

  const onClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.nativeEvent?.stopImmediatePropagation();
      if (!data.status && useNavigator.onLine) {
        openDeleteModal(FileType.Page, data.id);
        return;
      }
      sendIntentMessage(data);
    },
    [sendIntentMessage, data]
  );
  if (!isFocusEnv() || !onLine) {
    return null;
  }

  if (!isSupprotAbstract(data)) return null;
  return (
    <div onClick={onClick} className={`${styles["abstract-space"]} abstract-space`}>
      <div className={styles["icon"]} /> {t("AI.abstract")}
    </div>
  );
}

export default JoyspaceAbstract;
